"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateLocationDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@goparrot/common");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const interface_1 = require("../interface");
const UpdateNotificationDto_1 = require("./UpdateNotificationDto");
class UpdateLocationDto {
}
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => Boolean }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateLocationDto.prototype, "isCentralLocation", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => Boolean, default: false }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateLocationDto.prototype, "canCreateNewItems", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => Boolean, default: false }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateLocationDto.prototype, "canEditMenu", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => Boolean, default: false }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateLocationDto.prototype, "canEditConnections", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => Boolean, default: false }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateLocationDto.prototype, "isMenuRestrictionsEnabled", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ enum: interface_1.EditablePropertiesEnum, isArray: true, default: false }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsArray)({ always: true }),
    (0, class_validator_1.IsEnum)(interface_1.EditablePropertiesEnum, { always: true, each: true }),
    tslib_1.__metadata("design:type", Array)
], UpdateLocationDto.prototype, "editableProperties", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => UpdateNotificationDto_1.UpdateNotificationDto }),
    (0, class_transformer_1.Type)(() => UpdateNotificationDto_1.UpdateNotificationDto),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.ValidateNested)({ always: true }),
    tslib_1.__metadata("design:type", UpdateNotificationDto_1.UpdateNotificationDto)
], UpdateLocationDto.prototype, "notification", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, example: ['60dad945-ab24-4cc8-b8ff-fd553e7c33c4'] }),
    (0, class_transformer_1.Expose)({
        groups: [
            common_1.DefaultExposeGroupEnum.READ,
            common_1.DefaultExposeGroupEnum.CREATE,
            common_1.DefaultExposeGroupEnum.PATCH,
            common_1.DefaultExposeGroupEnum.UPDATE,
            common_1.DefaultExposeGroupEnum.FIXTURE,
            common_1.DefaultExposeGroupEnum.DELETE,
            interface_1.LocationExposeGroupEnum.BATCH_PATCH,
        ],
    }),
    (0, common_1.IsUndefinable)({ always: true }),
    (0, class_validator_1.IsArray)({ always: true }),
    (0, class_validator_1.IsString)({ each: true, always: true }),
    tslib_1.__metadata("design:type", Array)
], UpdateLocationDto.prototype, "itemSets", void 0);
exports.UpdateLocationDto = UpdateLocationDto;
//# sourceMappingURL=UpdateLocationDto.js.map